let chatAccessRedirectInFlight = false;
let genericErrorPage403InFlight = false;
function getAppRouter() {
    if (typeof window === "undefined")
        return undefined;
    return window.app?.$router;
}
function getAppStore() {
    if (typeof window === "undefined")
        return undefined;
    return window.app?.$store;
}
/** 403 từ API chat (không phải company_access_host_mismatch). */
export function isChatForbiddenResponse(status, responseData, requestUrl) {
    if (status !== 403)
        return false;
    const payload = responseData;
    if (payload?.data?.reason === "company_access_host_mismatch")
        return false;
    const url = String(requestUrl || "").toLowerCase();
    return url.includes("/chat/") || url.includes("/chat-group/");
}
export function extractChatGroupIdFromAxiosError(e) {
    const params = e.config?.params;
    if (params?.group_id != null && String(params.group_id) !== "") {
        return String(params.group_id);
    }
    const url = String(e.config?.url || "");
    const pathMatch = url.match(/\/chat\/groups\/(\d+)(?:\/|$)/i);
    if (pathMatch)
        return pathMatch[1];
    const pinMatch = url.match(/pin-messages\/(\d+)/i);
    if (pinMatch)
        return pinMatch[1];
    const queryMatch = url.match(/[?&]group_id=(\d+)/i);
    if (queryMatch)
        return queryMatch[1];
    const route = getAppRouter()?.currentRoute;
    if (route?.name === "messenger" && route.params?.messenger_id) {
        return String(route.params.messenger_id);
    }
    return null;
}
function pruneChatStateForGroup(store, groupId) {
    const chat = store.state.chat;
    if (!chat)
        return;
    const gid = String(groupId);
    const groups = (chat.chatGroups || []).filter((g) => String(g.id) !== gid);
    store.commit("chat/updateChatGroups", groups);
    const sel = chat.chatGroupSelected;
    if (sel && String(sel.id) === gid) {
        store.commit("chat/updateChatGroupSelected", groups[0] ? { ...groups[0] } : {});
    }
    const cache = { ...(chat.cacheChatMessages || {}) };
    delete cache[gid];
    store.commit("chat/updateCacheChatMessages", cache);
}
/**
 * User mất quyền nhóm (bị kick / không còn member): dọn store, thoát màn chat, không vào /error.
 */
export function redirectAfterChatGroupAccessLost(options) {
    if (typeof window === "undefined")
        return;
    if (chatAccessRedirectInFlight)
        return;
    const router = options?.router ?? getAppRouter();
    const store = options?.store ?? getAppStore();
    const route = router?.currentRoute;
    const path = String(route?.path || "").toLowerCase();
    const groupId = options?.groupId != null && String(options.groupId) !== ""
        ? String(options.groupId)
        : route?.name === "messenger" && route.params?.messenger_id
            ? String(route.params.messenger_id)
            : null;
    chatAccessRedirectInFlight = true;
    try {
        if (store && groupId) {
            pruneChatStateForGroup(store, groupId);
        }
        if (!router)
            return;
        const onForbiddenMessenger = route?.name === "messenger"
            && groupId
            && String(route.params?.messenger_id) === groupId;
        const onErrorPage = route?.name === "Error page" || path === "/error";
        if (onForbiddenMessenger || onErrorPage) {
            router.replace("/new-feeds").catch(() => { });
        }
    }
    finally {
        window.setTimeout(() => {
            chatAccessRedirectInFlight = false;
        }, 2500);
    }
}
/** 403 không thuộc chat — tối đa một lần, không lặp khi đã ở /error. */
export function redirectToErrorPageOnce(router) {
    const r = router ?? getAppRouter();
    if (!r)
        return;
    const path = String(r.currentRoute?.path || "").toLowerCase();
    if (path === "/error" || genericErrorPage403InFlight)
        return;
    genericErrorPage403InFlight = true;
    r.push({ name: "Error page" }).catch(() => { });
    window.setTimeout(() => {
        genericErrorPage403InFlight = false;
    }, 3000);
}
export function isChatGroupNotFoundResponse(res) {
    if (!res || typeof res !== "object")
        return false;
    const body = res;
    if (body.status !== false)
        return false;
    const msg = String(body.message || "").toLowerCase();
    return msg.includes("chat group not found") || msg.includes("not found");
}
